/**
 * Created by dv on 9/13/2017.
 */
import {GetRevisionsOfCollectionAssetMessage, GetRevisionsOfCollectionAssetQuery} from "../../autogenerated/ZoomBridge";
/**
 * Get a list of all revisions of the assets of a collection to compare.
 */
export default class GetRevisionsOfCollectionAsset {
  /**
   *
   * @param {number} collectionId
   * @param {FuidRrnInfo} fuidRrnInfo
   */
  constructor(collectionId, fuidRrnInfo) {
    this.collectionId = collectionId;
    this.fuidRrnInfo = fuidRrnInfo;
  }

  /**
   * Returns a {Promise} Instance with onSuccess and OnFailure method.
   * onSuccess method takes @type {GetRevisionsOfCollectionAssetResponse} resp type.
   * @return {Promise}
   * @public
   */
  run() {
    const query = new GetRevisionsOfCollectionAssetQuery();
    const msg = new GetRevisionsOfCollectionAssetMessage();
    msg.setCollectionId(this.collectionId);
    msg.setFuidRrnInfo(this.fuidRrnInfo);
    query.message = msg;
    return query.run();

  }
}
